import { ReactNode } from 'react';

export enum TStatusIcon {
  Blank,
  Red,
  Yellow,
  Blue,
  Green,
  Orange,
  Purple,
}

export interface IStatusProps {
  className?: string;
  icon: TStatusIcon;
  customIcon?: ReactNode;
  children: ReactNode;
}
